import axios from "axios";

const API = axios.create({
  baseURL:
    process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000/api",
  withCredentials: false, // set to true if you ever rely on cookies
});

export default API;
